<template>
    <form id="onboarding-de" class="wrapper tab-index" role="form" method="post">
        <header>
            <span class="new-headline-xlg text-centered">Was trifft auf Sie zu?</span>
        </header>

        <div class="form-input-radio-button-wrapper-two-columns">
            <div 
                class="form-input-radio-button-big"
                @click="chooseOption('rezept')"
                >
                <div class="form-input-radio-button-inner">
                    <figure>
                        <img src="imgs/web/svg/img_receipt.svg" alt="">
                    </figure> 
                    <strong class="new-headline-sm">Ich habe ein Rezept</strong>
                </div>
            </div>
            
            <div 
                class="form-input-radio-button-big"
                @click="chooseOption('app')"
                >
                <div class="form-input-radio-button-inner">
                    <div class="popup">
                        <span class="popup-icon">
                            <svg width="27" height="30" viewBox="0 0 27 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.4 26.3L11.9667 26.2667C8.67778 25.8889 5.93333 24.4889 3.73333 22.0667C1.55556 19.6222 0.466667 16.7444 0.466667 13.4333C0.466667 9.85555 1.71111 6.83333 4.2 4.36666C6.71111 1.87778 9.75556 0.633331 13.3333 0.633331C15.1111 0.633331 16.7778 0.977776 18.3333 1.66667C19.8889 2.33333 21.2444 3.25555 22.4 4.43333C23.5778 5.58889 24.5 6.94444 25.1667 8.5C25.8556 10.0556 26.2 11.7222 26.2 13.5C26.2 16.9889 25.1667 20.0889 23.1 22.8C21.0333 25.4889 18.4778 27.7667 15.4333 29.6333C15.1 29.8111 14.7556 29.9 14.4 29.9C14.0667 29.8778 13.7444 29.7778 13.4333 29.6C13.1222 29.4222 12.8778 29.1889 12.7 28.9C12.5222 28.5889 12.4333 28.2444 12.4333 27.8667L12.4 26.3ZM13.3333 21.1333C13.8444 21.1333 14.2667 20.9667 14.6 20.6333C14.9556 20.2778 15.1333 19.8444 15.1333 19.3333C15.1333 18.8222 14.9556 18.4 14.6 18.0667C14.2667 17.7111 13.8444 17.5333 13.3333 17.5333C12.8222 17.5333 12.3889 17.7111 12.0333 18.0667C11.7 18.4 11.5333 18.8222 11.5333 19.3333C11.5333 19.8444 11.7 20.2778 12.0333 20.6333C12.3889 20.9667 12.8222 21.1333 13.3333 21.1333ZM10.2667 10.8333C10.6222 10.9667 10.9667 10.9667 11.3 10.8333C11.6556 10.7 11.9556 10.4778 12.2 10.1667C12.3778 9.96667 12.5556 9.82222 12.7333 9.73333C12.9333 9.62222 13.1556 9.56667 13.4 9.56667C13.7778 9.56667 14.0889 9.67778 14.3333 9.9C14.6 10.1222 14.7333 10.3889 14.7333 10.7C14.7333 10.9667 14.6444 11.2556 14.4667 11.5667C14.2889 11.8778 14.0444 12.1778 13.7333 12.4667C13.2222 12.9333 12.8 13.4222 12.4667 13.9333C12.1333 14.4444 11.9667 14.8889 11.9667 15.2667C11.9667 15.6444 12.0889 15.9667 12.3333 16.2333C12.6 16.4778 12.9222 16.6 13.3 16.6C13.6111 16.6 13.8889 16.5 14.1333 16.3C14.3778 16.0778 14.5889 15.8222 14.7667 15.5333C14.9444 15.2 15.1333 14.8889 15.3333 14.6C15.5333 14.3111 15.7222 14.0778 15.9 13.9C16.5444 13.1889 16.9889 12.6 17.2333 12.1333C17.4778 11.6667 17.6 11.1444 17.6 10.5667C17.6 9.43333 17.2333 8.53333 16.5 7.86666C15.7889 7.2 14.8333 6.86666 13.6333 6.86666C12.8111 6.86666 12.0556 7.03333 11.3667 7.36666C10.6778 7.7 10.1556 8.14444 9.8 8.7C9.55556 9.1 9.46667 9.52222 9.53333 9.96667C9.62222 10.3889 9.86667 10.6778 10.2667 10.8333Z" fill="#5937B7"/>
                            </svg>
                        </span>

                        <div class="popup-wrapper">
                            <p class="new-text-lg"><strong>Als Diagnosenachweis gilt jedes Dokument, aus dem hervorgeht, dass bei Ihnen Diabetes Typ 2 diagnostiziert wurde, z.B.</strong></p>

                            <ul class="list-w-check">
                                <li>
                                    <figure>
                                        <span class="material-symbols-rounded full-circle icon-check-list text-green">
                                            <span>check</span>
                                        </span>
                                    </figure>
                                    <span class="new-text-md">Arztbrief</span>
                                </li>
                                <li>
                                    <figure>
                                        <span class="material-symbols-rounded full-circle icon-check-list text-green">
                                            <span>check</span>
                                        </span>
                                    </figure>
                                    <span class="new-text-md">Diabetespass</span>
                                </li>
                                <li>
                                    <figure>
                                        <span class="material-symbols-rounded full-circle icon-check-list text-green">
                                            <span>check</span>
                                        </span>
                                    </figure>
                                    <span class="new-text-md">Überweisungsschein</span>
                                </li>
                                <li>
                                    <figure>
                                        <span class="material-symbols-rounded full-circle icon-check-list text-green">
                                            <span>check</span>
                                        </span>
                                    </figure>
                                    <span class="new-text-md">Medikamentenplan</span>
                                </li>
                                <li>
                                    <figure>
                                        <span class="material-symbols-rounded full-circle icon-check-list text-green">
                                            <span>check</span>
                                        </span>
                                    </figure>
                                    <span class="new-text-md">Befundbericht</span>
                                </li>
                                <li>
                                    <figure>
                                        <span class="material-symbols-rounded full-circle icon-check-list text-green">
                                            <span>check</span>
                                        </span>
                                    </figure>
                                    <span class="new-text-md">AU</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <figure>
                        <img src="imgs/web/svg/img_diagnose.svg" alt="">
                    </figure> 
                    <strong class="new-headline-sm">Ich habe einen Diagnosenachweis</strong>
                </div>
            </div>

            <div 
                class="form-input-radio-button-big"
                @click="chooseOption('download')"
                >
                <div class="form-input-radio-button-inner">
                    <figure>
                        <img src="imgs/web/svg/img_code.svg" alt="">
                    </figure> 
                    <strong class="new-headline-sm">Ich habe einen Code von meiner Krankenkasse</strong>
                </div>
            </div>

            <div 
                class="form-input-radio-button-big"
                @click="chooseOption('none')"
                >
                <div class="form-input-radio-button-inner">
                    <figure>
                        <img src="imgs/web/svg/img_none.svg" alt="">
                    </figure> 
                    <strong class="new-headline-sm">Ich habe nichts der genannten</strong>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        data() {
            return {
            }
        },

        methods: {
            chooseOption(selection) {
                if (selection === 'rezept') {
                    window.location.href = '/rezept-service#rezept-service-form'
                } else {
                    setTimeout(() => {
                        this.$emit('clicked', selection)
                    }, 250);
                }
            },
        }
    }
</script>